export type RailView = 'Dashboard' | 'Monitor' | 'Trade' | 'Analyze' | 'Scan' | 'Charts' | 'Ratings' | 'Tools' | 'Bond' | 'ETF' | 'FX' | 'Orders' | 'Brokers' | 'Recon' | 'Funding' | 'CorpActions' | 'BestEx';

interface Props {
  active: RailView;
  onChange: (v: RailView) => void;
}

const ITEMS: Array<{ key: RailView; icon: string; label: string }> = [
  { key: 'Dashboard', icon: '⌂', label: 'Home' },
  { key: 'Monitor', icon: '▦', label: 'Monitor' },
  { key: 'Trade',   icon: '◑', label: 'Trade' },
  { key: 'Analyze', icon: '◎', label: 'Analyze' },
  { key: 'Scan',    icon: '⌕', label: 'Scan' },
  { key: 'Charts',  icon: '⬚', label: 'Charts' },
  { key: 'Ratings', icon: '★', label: 'Ratings' },
  { key: 'Tools',   icon: '⚙', label: 'Tools' },
  { key: 'Bond',    icon: '▤', label: 'Bond' },
  { key: 'ETF',     icon: '▣', label: 'ETF' },
  { key: 'FX',      icon: '◉', label: 'FX' },
  { key: 'Orders',  icon: '≣', label: 'Orders' },
  { key: 'Brokers', icon: '✵', label: 'Brokers' },
  { key: 'Recon',   icon: '⇌', label: 'Recon' },
  { key: 'Funding', icon: '₦', label: 'Funding' },
  { key: 'CorpActions', icon: '✪', label: 'Corp' },
  { key: 'BestEx',  icon: '★', label: 'BestEx' },
];

export function LeftRail({ active, onChange }: Props) {
  return (
    <div className="rail" role="tablist" aria-label="Workspace">
      {ITEMS.map((it) => (
        <button
          key={it.key}
          role="tab"
          aria-selected={active === it.key}
          className={active === it.key ? 'active' : ''}
          onClick={() => onChange(it.key)}
          title={it.label}
        >
          <span className="icon" aria-hidden>{it.icon}</span>
          <span className="label">{it.label.slice(0, 5)}</span>
        </button>
      ))}
    </div>
  );
}

